import { PageTypeResult } from '@westwing/appshell_types';

const useCurrentPageType = (): PageTypeResult => ({ pageType: '{{pagetype}}' } as unknown as PageTypeResult);

export default useCurrentPageType;
